/* eslint-disable */
import React from "react";

/**
 * Top-level error boundary. When a descendant throws during render
 * (common cause: passing a non-string like a Pydantic 422 detail array
 * to a toast/renderer → "Objects are not valid as a React child"),
 * we render a graceful recovery UI instead of unmounting the whole tree
 * to a blank white screen.
 */
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[Métier] ErrorBoundary caught:", error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error || "Unknown error");
    return (
      <div
        data-testid="app-error-boundary"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "48px 20px",
          background: "var(--cream, #f6f2ea)",
          color: "var(--m-text, #1b2340)",
          fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
        }}
      >
        <div style={{ maxWidth: 520, textAlign: "left" }}>
          <span className="m-eyebrow">Something went sideways</span>
          <h1 style={{ fontSize: 32, margin: "8px 0 12px" }}>
            The page ran into an error.
          </h1>
          <p style={{ opacity: 0.75, marginBottom: 20 }}>
            You can try again — your data is safe. If this keeps happening,
            let us know at{" "}
            <a href="mailto:contact@workmetier.com" style={{ color: "var(--gold)" }}>
              contact@workmetier.com
            </a>
            .
          </p>
          <details style={{ marginBottom: 24, fontSize: 12, opacity: 0.6 }}>
            <summary style={{ cursor: "pointer" }}>Technical details</summary>
            <pre style={{ whiteSpace: "pre-wrap", marginTop: 8 }}>{msg}</pre>
          </details>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              type="button"
              onClick={this.reset}
              className="m-btn-gold"
              data-testid="error-boundary-retry"
            >
              Try again
            </button>
            <button
              type="button"
              onClick={() => window.location.assign("/spaces")}
              className="m-btn-ghost"
              data-testid="error-boundary-home"
            >
              Back to workspaces
            </button>
          </div>
        </div>
      </div>
    );
  }
}
